import { EmployeeRecord, PaidTimeOffPolicy } from "winslow-core";
import "./AppEmployeeTimeOffBalancesCard.css";
import { useEffect, useState } from "react";
import { getPTODataForEmployeeRecord, PTOData } from "./ptoUtils";
import { toastFail } from "../../../config";
import toast from "react-hot-toast";
import { erGetCPValue } from "../app-employee-records/employeeRecordUtils";
import { apiGetEmployeeRecord } from "../../../services/EmployeeRecordService";
import { apiGetPaidTimeOffPoliciesForWorkspace } from "../../../services/PaidTimeOffPolicyService";

type AppEmployeeTimeOffBalancesCardProps = {
    employeeRecordId: string;
}

export const AppEmployeeTimeOffBalancesCard = ({ employeeRecordId }: AppEmployeeTimeOffBalancesCardProps) => {

    const [ptoData, setPtoData] = useState<PTOData | null>(null);
    const [employeeRecord, setEmployeeRecord] = useState<EmployeeRecord | null>(null);
    const [paidTimeOffPolicies, setPaidTimeOffPolicies] = useState<PaidTimeOffPolicy[] | null>(null);   
    const [selectedPolicyId, setSelectedPolicyId] = useState<string>("");
    const [systemPTOPolicies, setSystemPTOPolicies] = useState<string[] | undefined>(undefined);

    useEffect(() => {
        if (!ptoData){
            (async () => {
                const employeeRecord = await apiGetEmployeeRecord(employeeRecordId);

                if (!employeeRecord) {
                    toast("Unable to load employee record", toastFail);
                    return;
                }

                setEmployeeRecord(employeeRecord);

                const ptoPolicies = await apiGetPaidTimeOffPoliciesForWorkspace(employeeRecord.workspaceId);
                if (!ptoPolicies) {
                    toast("Unable to load PTO policies", toastFail);
                    return;
                }

                setPaidTimeOffPolicies(ptoPolicies);

                const thePTOData = await getPTODataForEmployeeRecord(
                    employeeRecord.id,
                    undefined,
                    new Date(),
                )

                if (!thePTOData) {
                    toast("Unable to load PTO data", toastFail);
                    return;
                }

                setPtoData(thePTOData);
                const thePolicies = erGetCPValue(employeeRecord, "system-PTOPolicies")

                setSystemPTOPolicies(thePolicies);
                setSelectedPolicyId(thePolicies ? thePolicies[0] : "");

            })();  
        }
    }, [employeeRecordId]);

    const selectedPolicy = paidTimeOffPolicies?.find((policy: PaidTimeOffPolicy) => policy.id === selectedPolicyId);

    console.log("[AppEmployeeTimeOffBalancesCard] employeeRecord", employeeRecord);
    console.log("[AppEmployeeTimeOffBalancesCard] paidTimeOffPolicies", paidTimeOffPolicies);
    console.log("[AppEmployeeTimeOffBalancesCard] systemPTOPolicies", systemPTOPolicies);
    console.log("[AppEmployeeTimeOffBalancesCard] ptoData", ptoData);
    console.log("[AppEmployeeTimeOffBalancesCard] selectedPolicyId", selectedPolicyId);
    
    return (
        <div className="app-employee-time-off-balances-card">
            <h2>Time Off Balances</h2>
            <div className="app-employee-time-off-balances-card-policies">
                
                {systemPTOPolicies && paidTimeOffPolicies &&
                    <select 
                        className="app-employee-time-off-balances-card-policies-select"
                        value={selectedPolicyId}
                        onChange={(e) => {
                            setSelectedPolicyId(e.target.value);
                        }}
                    >
                        {systemPTOPolicies.map((systemPolicyId: string) => {
                            const selectedPolicy = paidTimeOffPolicies.find((policy: PaidTimeOffPolicy) => policy.id === systemPolicyId);
                           
                            if (!selectedPolicy) {
                                return null;
                            }

                            return (
                                <option 
                                    key={selectedPolicy.id}
                                    value={selectedPolicy.id}
                                >
                                    {selectedPolicy.name}
                                </option>
                            )
                        })}
                    </select>
                }
            </div>

            <div className="app-employee-time-off-balances-card-balance">
                {ptoData && selectedPolicyId && 
                    <>
                        <div>
                            {/* <h3>{paidTimeOffPolicies.find((policy: PaidTimeOffPolicy) => policy.id === selectedPolicyId)?.name}</h3> */}
                            <p>Balance: {ptoData.accrualMap.get(selectedPolicyId)}</p>
                        </div>
                        <div>
                            {selectedPolicy?.accrualCap !== undefined ? "Accrual Cap: " + selectedPolicy?.accrualCap : "No Accrual Cap"}
                        </div>
                        <div>
                            {selectedPolicy?.carryoverCap !== undefined ? "Carryover Cap: " + selectedPolicy?.carryoverCap : "No Carryover Cap"}
                        </div>
                       
                    </>
                }
            </div>
        </div>
    );
}
